import { Button } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { TemplateLink } from 'utils/link';
import { AddIcon } from 'components/uiIcons';
import { ButtonSpan } from 'components/styles_components/span';
import Create from 'components/template/modal/create';

const CreateButton = ({ disabled }) => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();
  const navigate = useNavigate();

  return (
    <Button
      disabled={disabled}
      endIcon={<AddIcon />}
      onClick={() =>
        addModal(
          <Create
            handleClose={() => removeModal()}
            onSuccess={(template) => {
              removeModal();
              setInfo('info.template.created');
              navigate(TemplateLink(template.id));
            }}
          />,
          { disableAutoFocus: true, disableRestoreFocus: true }
        )
      }
      variant="contained"
    >
      <ButtonSpan>
        <FormattedMessage id="button.add" />
      </ButtonSpan>
    </Button>
  );
};

export default CreateButton;
